export const statusColor = (status) => {
  const key = String(status || "").toLowerCase();
  if (["submitted"].includes(key)) return "warning";
  if (["review", "processing", "shortlisted"].includes(key)) return "info";
  if (["matched"].includes(key)) return "secondary";
  if (["active", "signed"].includes(key)) return "success";
  if (["expired", "rejected", "closed"].includes(key)) return "default";
  return "default";
};

export const formatCurrency = (amountInCents, currency = "usd") =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: String(currency || "usd").toUpperCase(),
  }).format((Number(amountInCents || 0)) / 100);

export const formatDate = (timestamp) => {
  if (timestamp instanceof Date && !Number.isNaN(timestamp.getTime())) {
    return timestamp.toLocaleDateString();
  }
  if (typeof timestamp === "number" && Number.isFinite(timestamp) && timestamp > 0) {
    const ms = timestamp > 1e12 ? timestamp : timestamp * 1000;
    const dt = new Date(ms);
    if (!Number.isNaN(dt.getTime())) return dt.toLocaleDateString();
  }
  const sec = Number(timestamp?.seconds || timestamp?._seconds || 0);
  if (sec > 0) return new Date(sec * 1000).toLocaleDateString();
  if (typeof timestamp?.toDate === "function") {
    const dt = timestamp.toDate();
    if (dt instanceof Date && !Number.isNaN(dt.getTime())) return dt.toLocaleDateString();
  }
  return "-";
};

export const normalizeError = (error, fallback) => {
  const text = String(error?.message || "").replace(/^Firebase:\s*/i, "").trim();
  return text || fallback;
};

export const buildDisplayName = (user) => {
  const name = `${user?.fname || ""} ${user?.lname || ""}`.trim();
  const displayName = String(user?.displayName || "").trim();
  return name || displayName || "User";
};

export const isEmailLike = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());

